export default __webpack_public_path__ + "static/tile-featured-1-edf86e6b20882b78c8623440e5087397.jpg";